<span *ngIf="device.osBlock"><i
    class="fas fa-lock"></i></span>
{{device.os && 'OsType.' + device.os | translate}}
{{device.osVersion}}

<span class="ghost-remote-img isGhost" *ngIf="isGhost">
    AAAAA X.X.X
</span>
